var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.computedClass.length === 0)?_c('figure',{staticClass:"c-image"},[_c('img',{attrs:{"src":_vm.computedSrc,"alt":_vm.alt}})]):_c('div',{class:['c-image', _vm.computedClass],style:(("background-image: url(" + _vm.computedSrc + ")"))})}
var staticRenderFns = []

export { render, staticRenderFns }